"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTokenHelper = exports.createJWTToken = void 0;
const faker_1 = require("@faker-js/faker");
const jwt_encode_1 = __importDefault(require("./libs/jwt-encode"));
const tokenHelper_1 = require("./tokenHelper");
const createBaseToken = () => ({
    v: 2,
    azp: 'users-fe',
    jti: faker_1.faker.string.uuid(),
    iss: 'https://keycloak.staging.eu1.meta.klarna.net/auth/realms/merchants',
    session_state: '32591c77-63d8-44b5-a862-bb97155c362b',
    sub: '12345678-2c34-4174-8582-098765432112',
    preferred_username: 'JaneCDoe',
    given_name: 'Jane',
    family_name: 'Doe',
    name: 'Jane C. Doe',
    email: 'jane_doe@klarna.com',
    aud: 'ember',
    exp: Math.floor(Date.now() / 1000) + (60 * 60), // 1 hour in the future
    scope: 'openid klarna email profile',
    groups: [{
            group_id: 'a536632b-1bda-4fe9-9890-76c6bffd44af',
            name: 'META Store'
        }]
});
const createTokenHelper = (token = {}) => {
    const baseToken = createBaseToken();
    const jwt = (0, jwt_encode_1.default)(Object.assign(Object.assign({}, baseToken), token), 'shhhhh');
    return (0, tokenHelper_1.tokenHelperFactory)(jwt);
};
exports.createTokenHelper = createTokenHelper;
const createToken = (token = {}) => {
    const baseToken = createBaseToken();
    return Object.assign(Object.assign(Object.assign({}, baseToken), { pids: ['P12345678'], resource_access: {
            'orders-fe': {
                roles: ['merchant-full', 'merchant-limited']
            },
            'users-fe': {
                roles: ['merchant-full']
            }
        }, realm_access: {
            roles: ['merchant-admin']
        }, merchant_permissions: {
            K11111: {
                'orders-fe': ['merchant-read-only'],
                'settlements-fe': ['merchant-full']
            },
            K22222: {
                'settlements-fe': ['merchant-limited']
            },
            K33333: {}
        }, merchant_permissions_pending: {
            K55555: {
                'orders-fe': ['merchant-read-only'],
                'settlements-fe': ['merchant-full']
            },
            K66666: {
                'settlements-fe': ['merchant-limited']
            },
            K77777: {}
        }, merchant_roles: {
            K11111: ['partner-admin'],
            K22222: []
        }, platform_permissions: {
            'krn:css:merchant:se:2': {
                'klarna-search-b2b-portal': [
                    'merchant-read'
                ]
            }
        }, platform_roles: {
            'krn:css:merchant:se:2': ['platform-role']
        }, estore_permissions: {
            1111: {
                'insights-fe': ['merchant-full']
            },
            2222: {
                'settlements-fe': ['merchant-limited'],
                'logs-app-fe': ['merchant-limited']
            },
            3333: {}
        }, estore_roles: {
            1111: ['merchant-nko'],
            2222: []
        }, user_attributes: {
            roles: ['1111: admin', '2222: user']
        } }), token);
};
const createJwtToken = (token = {}) => (0, jwt_encode_1.default)(createToken(token), 'shhhhh');
exports.createJWTToken = createJwtToken;
